import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md } from '../../../../../../theme/Component/hooks/useModal';
import { Modal } from '../../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import { _single } from '../../../../../../../core/services/dataBean/EntityCatalog';
import { _CatalogByAccount, _CatalogByIncomeResponsible } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const CatalogByIncomeResponsible = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CatalogByAccount)
    const [id, setID] = useState(null);

    const modal = useModal("Concepto Contable de Ajuste", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDIncomeResponsibleConcept == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getIncomeResponsibleConceptCatalogByAccount(_single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDIncomeResponsibleConcept', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Línea de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Utilizar Presupuesto ?', property: 'UseBudget', visible: true },
        { title: 'Tipo de Presupuesto a Afectar', property: 'BudgetTypeName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Concepto Contable de Ajuste"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDIncomeResponsibleConcept); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}